<script>
import BaseTileDropdown from '@/components/BaseTileDropdown.vue';

export default {
  name: 'BaseStatusTile',
  components: { BaseTileDropdown },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: String,
    changeable: Boolean,
    editable: Boolean,
    gray: Boolean,
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      editing: false,
      dropdownOpened: false,
    };
  },
  computed: {
    currStatus() { return this.items.find((item) => item['@id'] === this.value); },
    label() { return this.currStatus?.name ?? 'Без статуса'; },
    color() { return this.currStatus?.color ?? '#000'; },
  },
  methods: {
    onStatusSelected(item) {
      if (this.editing) {
        this.editing = false;
        return;
      }

      this.dropdownOpened = false;
      this.$emit('change', item['@id']);
    },
    onDropdownClick() {
      if (this.editing) {
        this.editing = false;
        return;
      }

      this.dropdownOpened = false;
    },
  },
};
</script>

<template lang="pug">
  .b-status(:class="{ gray }" :style="`background: ${color}`" v-if="!changeable" :title="label") {{ label }}
  BaseTileDropdown(v-else :opened="dropdownOpened" @close="onDropdownClick")
    template(#selected)
      .b-status(:class="{ gray }" :style="`background: ${color}`" @click="dropdownOpened = !dropdownOpened; editing = false" :title="label").-clickable {{ label }}
    template(#default)
      template(v-if="editing")
        .status-with-buttons(v-for="item in items" :key="item.name")
          .b-status(:style="`background: ${item.color}`" @click="onStatusSelected(item)").-clickable {{ item.name }}
          button.status-btn(@click="$emit('update', item)")
            Icon(name="edit" colored pointer)
          button.status-btn(@click="$emit('remove', item)")
            Icon(name="trash" colored pointer)
      template(v-else)
        .b-status(v-for="item in items" :key="item.name" :style="`background: ${item.color}`" @click="onStatusSelected(item)").-clickable {{ item.name }}
      Btn.footer-btn(sm dark v-if="editing" @click="$emit('create')")
        Icon(name="plus" key="i0" colored pointer)
        | Добавить
      Btn.footer-btn(sm dark v-if="editable && !editing" @click="editing = true")
        Icon(key="i1" name="settings" colored pointer)
        | Настроить
</template>

<style scoped lang="scss">
.status-with-buttons {
  display: grid;
  grid-template-columns: 1fr 25px 25px;
}

.status-btn {
  padding: 0;
  background: transparent;
  border: none;
  outline: none;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;

  svg {
    color: #788CA1;
    display: block;
  }
}

.footer-btn {
  margin-top: 10px;

  svg {
    color: #2EE1CE;
    height: 15px;
    width: 15px;
  }
}

.status {
  display: block;
  text-align: center;
  color: var(--color-white);
  font-weight: 700;
  font-size: 12px;
  line-height: 1.15;
  width: 125px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  padding: 4px 8px;
  border-radius: 4px;

  &--clickable {
    cursor: pointer;
  }

  &.gray {
    filter: grayscale(1);
    opacity: .6;
  }
}
</style>
